module.exports = __webpack_public_path__ + "img/car1.8d2baa0f.png";